import { render, staticRenderFns } from "./StartupCards.vue?vue&type=template&id=44f1c940"
import script from "./StartupCards.vue?vue&type=script&lang=js"
export * from "./StartupCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports